<ng-container *ngIf="user && user.getDisplayName()">
    <div class="flex-row">
        <i
            *ngIf="user.isInactive === true && showInactiveUser === true"
            aria-hidden="true"
            class="cc-error-text-color"
            title="Inactive User"
            [ngClass]="iconExclamatory"
        ></i>
        <div *ngIf="userHasProfile" class="flex-row">
            <app-hyperlink-creator
                [displayText]="user.getDisplayName()"
                [communityId]="communityId"
                (onLinkClick)="onUserClick()"
            ></app-hyperlink-creator>
        </div>
        <span *ngIf="!user.hasProfile || (user.notApprovedProfile && !canManageProfile)">
            {{ user.getDisplayName() }}
        </span>
        <span *ngIf="user.notApprovedProfile && canManageProfile">
            <i aria-hidden="true" [ngClass]="iconLock"></i>
        </span>
    </div>
    <ng-content></ng-content>
</ng-container>

<app-user-biography #userBiography *ngIf="showBiography" [mode]="'popup'" (onClose)="onBioClose()"></app-user-biography>
